import { createAction, props } from '@ngrx/store';
import { VideoReviewType } from '@app/home/services/home.service';

const REALPROPERTY = 'REAL PROPERTY';

export const getRealPropertyData = createAction(`[${REALPROPERTY}] Get Data`, props<{ filter: any }>());
export const getRealPropertyDataSuccess = createAction(`[${REALPROPERTY}] Get Data Success`, props<{ data: any, totalCountData: number }>());
export const getRealPropertyDataFailure = createAction(`[${REALPROPERTY}] Get Data Failure`, props<{ errorMessage: string }>());

export const updateRealPropertyItemSuccess = createAction(`[${REALPROPERTY}] Update Item`, props<{ item: any }>());

export const getRealPropertyDataCount = createAction(`[${REALPROPERTY}] Get Count`, props<{ filter: any }>());
export const getRealPropertyDataCountSuccess = createAction(`[${REALPROPERTY}] Get Count Success`, props<{ count: number }>());
export const getRealPropertyDataCountFailure = createAction(`[${REALPROPERTY}] Get Count Failure`, props<{ errorMessage: string }>());

export const getTop10RealProperty = createAction(`[${REALPROPERTY}] Get Top 10`);
export const getTop10RealPropertySuccess = createAction(`[${REALPROPERTY}] Get Top 10 Success`, props<{ data: VideoReviewType[] }>());
export const getTop10RealPropertyFailure = createAction(`[${REALPROPERTY}] Get Top 10 Failure`, props<{ errorMessage: string }>());

export const getMoreTop10Property = createAction(`[${REALPROPERTY}] Get More top 10`, props<{ size: number }>());

export const getTop100Property = createAction(`[${REALPROPERTY}] Get top 100`);
export const getTop100PropertySuccess = createAction(`[${REALPROPERTY}] Get Top 100 Success`, props<{ data: any[], totalCountData: number }>());
export const getTop100PropertyFailure = createAction(`[${REALPROPERTY}] Get Top 100 Failure`, props<{ errorMessage: string }>());

export const getMoreTop100Property = createAction(`[${REALPROPERTY}] Get More top 100`, props<{ startIndex: number, endIndex: number }>());

export const getHotDealsProperty = createAction(`[${REALPROPERTY}] Get Hot Deals`);
export const getHotDealsPropertySuccess = createAction(`[${REALPROPERTY}] Get Hot Deals Success`, props<{ data: VideoReviewType[] }>());
export const getHotDealsPropertyFailure = createAction(`[${REALPROPERTY}] Get Hot Deals Failure`, props<{ errorMessage: string }>());

export const getMoreHotDealsProperty = createAction(`[${REALPROPERTY}] Get More Hot Deals`, props<{ size: number }>());
